import React, { useState } from 'react';
import { number, string, func, bool } from 'prop-types';

import { RatingsAndReviews } from '@thd-olt-component-react/ratings-and-reviews';
import { Rating } from '@thd-olt-component-react/rating';

import { noop } from '../../../../utils/promo-utils';
import { PromoSidecar } from '../../../promo-sidecar/PromoSidecar';
import { PromoQuickviewSectionCta } from '../promo-quickview-section-cta/PromoQuickviewSectionCta';
import '../../PromoQuickview.scss';
import './PromoQuickviewReviews.scss';

export const PromoQuickviewReviews = ({
  itemId,
  averageRating,
  totalRatings,
  closeDrawer,
  onSectionClick,
  selected,
  onSelect,
  setQuantityWarningText,
  showQuantityWarningState
}) => {
  const [renderReviews, setRenderReviews] = useState(false);
  const [isReviewsOpen, setIsReviewsOpen] = useState(false);
  return (
    <>
      <PromoQuickviewSectionCta
        setOpen={setIsReviewsOpen}
        setRender={setRenderReviews}
        clickAnalytics={onSectionClick}
        sectionName="Reviews"
      >
        <div className="promo-quickview-reviews-ratings">
          <Rating value={averageRating} />
          <span>({totalRatings})</span>
        </div>
        <div className="promo-quickview-section--fill" />
      </PromoQuickviewSectionCta>

      {renderReviews && (
        <PromoSidecar
          isSidecarOpen={isReviewsOpen}
          setIsSidecarOpen={setIsReviewsOpen}
          closeDrawer={closeDrawer}
          zIndex={1000}
          backText="Back to Quick View"
          itemId={itemId}
          useSidecarNav
          useSidecarCta
          selected={selected}
          onSelect={onSelect}
          setQuantityWarningText={setQuantityWarningText}
          showQuantityWarningState={showQuantityWarningState}
        >
          <article className="promo-quickview-section-sidecar">
            <RatingsAndReviews itemId={itemId} forceCondensedLayout />
          </article>
        </PromoSidecar>
      )}
    </>
  );
};

PromoQuickviewReviews.displayName = 'PromoQuickviewReviews';

PromoQuickviewReviews.propTypes = {
  averageRating: number.isRequired,
  totalRatings: string.isRequired,
  itemId: string.isRequired,
  closeDrawer: func.isRequired,
  onSectionClick: func,
  selected: bool.isRequired,
  onSelect: func.isRequired,
  setQuantityWarningText: func,
  showQuantityWarningState: bool
};

PromoQuickviewReviews.defaultProps = {
  onSectionClick: noop,
  setQuantityWarningText: noop,
  showQuantityWarningState: false
};
